<div class="footer">
  <nav>
    <a class="footer-link" routerLink="/datenschutz">Datenschutz</a> |
    <a class="footer-link" routerLink="/impressum">Impressum</a>
  </nav>
  <p>© {{ currentYear }} WAVE Campus GmbH. Alle Rechte vorbehalten.</p>
</div>
